<template>
  <div>
    <el-dialog
      v-if="!showEventPopupFlag"
      class="tag-dialog"
      :visible.sync="dialogVisible"
      :show-close="false"
      @close="closeTagPopup"
    >
      <div class="tag-dialog-body">
        <div class="tag-dialog-main-title m-bottom-3">
          {{ query.title }}{{ $t('label.tag.popup.title') }}
        </div>
        <div class="tag-dialog-sub-title m-bottom-1">
          {{ $t('label.tag.popup.subTitle') }}
        </div>
        <div class="tag-dialog-tips-title m-bottom-4">
          {{ $t('label.tag.popup.tips') }}
        </div>
        <div class="tag-dialog-form">
          <el-form
            :rules="rules"
            :model="query"
            ref="ruleForm"
          >
            <div v-for="(info, index) in query.tagList" :key="index">
              <el-form-item :prop="'tagList.' + index + '.location'" :rules="rules.location">
                <div class="tag-input-box">
                  <div class="tag-input-text">
                    {{ index + 1 }}
                  </div>
                  <el-input v-model="info.tagName" class="tag-input" maxlength="20" :placeholder="query.title + $t('label.tag.popup.inputTitle')" />
                </div>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="tag-dialog-button">
          <el-button class="tag-dialog-create" @click="eventApi">
            {{ $t('label.tag.button.create') }}
          </el-button>
          <el-button class="tag-dialog-cancel" @click="closeTagPopup">
            {{ $t('label.tag.button.cancel') }}
          </el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      class="tag-fin-dialog"
      :visible.sync="showEventPopupFlag"
      :show-close="false"
    >
      <div class="tag-fin-dialog-body">
        <div class="tag-dialog-main-title text-align-center m-bottom-2">
          {{ $t('label.tag.popup.mainTitle1') }}
        </div>
        <div class="tag-dialog-main-title text-align-center m-bottom-2">
          {{ $t('label.tag.popup.mainTitle2') }}
        </div>
        <div class="tag-dialog-main-title text-align-center m-bottom-3">
          {{ $t('label.tag.popup.mainTitleSub') }}
        </div>
        <div class="tag-dialog-tips-title text-align-center m-bottom-5">
          {{ $t('label.tag.popup.tips') }}
        </div>
      </div>
      <div class="tag-dialog-button">
        <el-button class="tag-dialog-create" @click="eventUpdataApi">
          {{ $t('label.tag.button.ok') }}
        </el-button>
        <el-button class="tag-dialog-cancel" @click="closeFinTagPopup">
          {{ $t('label.tag.button.cancel') }}
        </el-button>
      </div>
    </el-dialog>
    <loading-dialog :dialogVisible="showLoading" />
  </div>
</template>

<script>
import SystemManageApi from "@/api/SystemManageApi"
import errorCodeMsg from "@/utils/error-code-msg"
import statusErrorCodeMsg from "@/utils/status-error-msg"
import LoadingDialog from "@/components/common/loading/LoadingDialog"

export default {
  components: {
    LoadingDialog
  },
  name: "TagPopup",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    buildId: {
      type: String,
      default: null
    },
    /*
    ** 会議室備品区分フラグ
    ** 01 会議室
    ** 02 備品
    */
    tagKbnFlg: {
      type: String,
      default: '02'
    }
  },
  data () {
    const lengthVerificationCheck = (rule, value, callback, index) => {
      let indexs = null
      for (const key in index) {
        indexs = key
        indexs = indexs.replace('tagList.', '')
        indexs = indexs.replace('.location', '')
      }
      if (!(typeof this.query.tagList[indexs].tagName === 'undefined' || this.query.tagList[indexs].tagName === null || String(this.query.tagList[indexs].tagName).replace(/\s*/g, '') === '')) {
        if (this.query.tagList[indexs].tagName.length > 20) {
          callback(new Error(
            this.$t('message.common.validation.size', {
              field: this.query.title,
              length: 20
            })
          ))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      dialogVisible: false,
      showLoading: false,
      showEventPopupFlag: false,
      query: {
        title: null,
        tagList: []
      },
      rules: {
        location: [
          {
            validator: lengthVerificationCheck,
            trigger: ['change', 'blur']
          }
        ]
      }
    }
  },
  watch: {
    visible (val) {
      this.dialogVisible = val
      if (this.dialogVisible) {
        this.loadInfo()
      }
    }
  },
  methods: {
    loadInfo () {
      this.showLoading = true
      this.query.title = this.$t('label.tag.popup.equipment')
      this.query.tagList = []
      SystemManageApi.getEquipmentTagList(this.buildId)
        .catch((error) => {
          this.showLoading = false
          errorCodeMsg(error, this)
        })
        .then(({ data }) => {
          if (!statusErrorCodeMsg(data.statusCode, this)) {
            this.showLoading = false
            return
          }
          if (data.body !== null) {
            data.body.forEach((info) => {
              this.query.tagList.push({
                tagId: info.equipmentTagId,
                tagName: info.equipmentTagName,
                buildingId: info.buildingId,
                deleteFlag: info.deleteFlag
              })
            })
          }
          this.showLoading = false
        })
    },
    eventApi () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.showEventPopupFlag = true
        }
      })
    },
    eventUpdataApi () {
      this.showLoading = true
      let equipmentTagList = []
      this.query.tagList.forEach((info) => {
        equipmentTagList.push({
          equipmentTagId: info.tagId,
          equipmentTagName: info.tagName == '' ? null : info.tagName
        })
      })
      SystemManageApi.equipmentTagUpdate(this.buildId, equipmentTagList)
        .catch((error) => {
          errorCodeMsg(error, this)
          this.showLoading = false
        })
        .then(({data}) => {
          this.showLoading = false
          if (!statusErrorCodeMsg(data.statusCode, this)) {
            return;
          }
          this.$emit("updata")
          this.closeTagPopup()
        })
    },
    closeFinTagPopup () {
      this.showEventPopupFlag = false
    },
    closeTagPopup () {
      this.dialogVisible = false
      this.showEventPopupFlag = false
      this.$emit('update:visible', false)
      if (this.$refs['ruleForm']) {
        this.$refs['ruleForm'].resetFields();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .tag-dialog .el-dialog {
  width: 812px;
  height: 645px;
  background: #F2F2ED;
  box-shadow: 3px 3px 12px rgba(6, 7, 8, 0.25);
  border-radius: 6px !important;
  padding: 40px !important;
  .el-dialog__header {
    display: none;
  }
}
::v-deep .tag-fin-dialog .el-dialog {
  width: 737px;
  height: 343px;
  background: #F2F2ED;
  box-shadow: 3px 3px 12px rgba(6, 7, 8, 0.25);
  border-radius: 6px !important;
  padding: 40px !important;
  .el-dialog__header {
    display: none;
  }
}
.tag-dialog-main-title {
  font-family: 'Hiragino Kaku Gothic Pro', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 24px;
  color: #525250;
}
.tag-dialog-sub-title {
  font-family: 'Hiragino Kaku Gothic Pro', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 16px;
  color: #525250;
}
.tag-dialog-tips-title {
  font-family: 'Hiragino Kaku Gothic Pro', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #525250;
}
.tag-input-box {
  display: flex;
  align-items: center;
  margin-right: 40px;
  margin-left: -8px;
}
.tag-input-text {
  width: 20px;
  text-align: right;
  margin-right: 12px;
  font-family: 'Hiragino Kaku Gothic Pro', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 36px;
  color: #525250;
}
.tag-input {
  width: 324px;
}
::v-deep .tag-input .el-input__inner {
  background: #F7F7F2;
  width: 324px;
  box-shadow: inset 3px 3px 3px #DEDED1, inset -3px -3px 4px #FFFFFA;
  border-radius: 8px;
  font-family: 'Hiragino Kaku Gothic ProN', sans-serif !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #000000 !important;
}
.tag-dialog-form .el-form {
  display: flex;
  flex-wrap: wrap;
  height: 356px;
  flex-direction: column;
}
.tag-dialog-form .el-form-item {
  margin-bottom: 30px !important;
}
.tag-dialog-button {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.tag-dialog-create {
  margin-left: 0;
  margin-right: 0;
  margin-top: 6px;
  padding: 10px;
  gap: 10px;
  width: 296px;
  height: 40px;
  font-family: 'Hiragino Kaku Gothic Pro', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  color: #FFFFFF;
  background: #329CA6;
  border: none;
  box-shadow: -4px -4px 5px #FFFFFF, 3px 3px 6px #B8B8AD;
  border-radius: 8px;
}
.tag-dialog-create:hover {
  opacity: 0.8;
}
.tag-dialog-create:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.tag-dialog-cancel {
  margin-left: 0;
  margin-right: 0;
  margin-top: 20px;
  font-family: 'Hiragino Kaku Gothic Pro', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  line-height: 11px;
  color: #329CA6;
  border: none;
  background: none;
}
.tag-dialog-cancel:hover {
  opacity: 0.8;
}
.tag-dialog-cancel:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
::v-deep .tag-dialog-form .el-form-item__error {
  margin-left: 26px;
  width: 324px;
}
.tag-input::placeholder {
  font-family: 'Hiragino Kaku Gothic ProN', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #B8B8B3;
}
.text-align-center {
  text-align: center;
}
</style>
